(function () {
  if (!window.themeVariables || !window.themeVariables.routes) {
    return;
  }

  const strings = window.cBoostProductEnrich || {};
  const buyLabel = (strings.buyLabel && String(strings.buyLabel).trim()) || strings.addToCart || 'Buy';
  const soldOut = strings.soldOut || 'Sold out';
  const showDiscount = strings.showDiscount !== false;
  const judgeMeOnBoost = strings.judgeMeOnBoost === true;
  const judgeMeDisableBootstrap = strings.judgeMeDisableBootstrap === true;

  var judgeMeNextReloadAt = 0;
  var judgeMeReloadCount = 0;
  const JUDGE_ME_RELOAD_MAX = 14;
  const JUDGE_ME_RELOAD_GAP_MS = 600;

  function runJudgeMeCaptionFormat() {
    if (window.cJdgmPreviewBadgeFormat && typeof window.cJdgmPreviewBadgeFormat.runAll === 'function') {
      try {
        window.cJdgmPreviewBadgeFormat.runAll();
      } catch (e) { }
    }
  }

  function safeReloadJudgeMeWidgets() {
    var now = Date.now();
    if (judgeMeReloadCount >= JUDGE_ME_RELOAD_MAX) {
      return;
    }
    if (now < judgeMeNextReloadAt) {
      return;
    }
    judgeMeReloadCount += 1;
    judgeMeNextReloadAt = now + JUDGE_ME_RELOAD_GAP_MS;
    var j = window.jdgm;
    var done = false;
    if (j && typeof j.reloadWidgets === 'function') {
      try {
        j.reloadWidgets();
        done = true;
      } catch (e) { }
    }
    if (!done && j && j.api && typeof j.api.refreshWidgets === 'function') {
      try {
        j.api.refreshWidgets();
        done = true;
      } catch (e2) { }
    }
    if (!done && j && typeof j.refreshWidgets === 'function') {
      try {
        j.refreshWidgets();
        done = true;
      } catch (e3) { }
    }
    if (!done && j && typeof j.initializeWidgets === 'function') {
      try {
        j.initializeWidgets();
        done = true;
      } catch (e4) { }
    }
    if (!done) {
      try {
        document.dispatchEvent(new Event('jdgm:refresh', { bubbles: true }));
      } catch (e5) {
        try {
          document.dispatchEvent(new Event('jdgm:refresh'));
        } catch (e6) { }
      }
    }
    runJudgeMeCaptionFormat();
  }

  var judgeMeBootstrapPlanned = false;
  var judgeMeDebounceT = null;

  function planJudgeMeBootstrap() {
    if (judgeMeDisableBootstrap) {
      return;
    }
    if (!judgeMeBootstrapPlanned) {
      judgeMeBootstrapPlanned = true;
      [400, 2000, 8000, 15000].forEach(function (ms) {
        setTimeout(function () {
          safeReloadJudgeMeWidgets();
        }, ms);
      });
    }
    if (judgeMeDebounceT) {
      clearTimeout(judgeMeDebounceT);
    }
    judgeMeDebounceT = setTimeout(function () {
      judgeMeDebounceT = null;
      safeReloadJudgeMeWidgets();
    }, 1000);
  }

  function buildSellHref(product) {
    const base = (strings.sellBaseUrl && String(strings.sellBaseUrl).trim()) || '#';
    if (base === '#') {
      return '#';
    }
    const key = (strings.sellQueryKey && String(strings.sellQueryKey).trim()) || 'handle';
    const h = (product && product.handle) || '';
    const sep = base.indexOf('?') === -1 ? '?' : '&';
    return base + sep + key + '=' + encodeURIComponent(h);
  }

  function buildSellControl(product) {
    const href = buildSellHref(product);
    const el = document.createElement('button');
    el.type = 'button';
    el.className = 'c-boost-product-item__btn-sell';
    el.textContent = strings.sellLabel || 'Sell';
    el.setAttribute('aria-label', (strings.sellLabel || 'Sell') + (href === '#' ? '' : ': ' + href));
    el.addEventListener('mousedown', function (e) {
      e.stopPropagation();
    });
    el.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.metaKey || e.ctrlKey) {
        if (href && href !== '#') {
          window.open(href, '_blank', 'noopener,noreferrer');
        }
        return;
      }
      if (href && href !== '#') {
        window.location.assign(href);
      }
    });
    return el;
  }

  const BOOST_SCOPE = 'c-boost-ai';
  const BOOST_ROOT_SELECTORS = ['.boost-sd__fpl-app-block', '.boost-sd__filter-product-list'];

  function tagBoostScopeClass() {
    BOOST_ROOT_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.classList.add(BOOST_SCOPE);
      });
    });
  }

  function patchSortButtonAccessibility() {
    var label =
      (window.cBoostProductEnrich && window.cBoostProductEnrich.sortButtonAriaLabel) || 'Sort by';
    document.querySelectorAll('.boost-sd__sorting .boost-sd__sorting-button').forEach(function (btn) {
      if (!btn.getAttribute('aria-label')) {
        btn.setAttribute('aria-label', label);
      }
    });
  }

  function patchFilterToggleLabel() {
    var cfg = window.cBoostProductEnrich || {};
    var text = (cfg.filterToggleLabel && String(cfg.filterToggleLabel).trim()) || '';
    if (!text) {
      return;
    }
    document.querySelectorAll('.boost-sd__filter-tree-toggle-button-title').forEach(function (el) {
      el.textContent = text;
    });
    document.querySelectorAll('.boost-sd__filter-tree-toggle-button-text').forEach(function (el) {
      el.textContent = text;
    });
    var aria = (cfg.filterToggleAriaLabel && String(cfg.filterToggleAriaLabel).trim()) || text;
    document.querySelectorAll('.boost-sd__filter-tree-toggle-button').forEach(function (btn) {
      btn.setAttribute('aria-label', aria);
    });
  }

  function appendCtaRowWithSell(cta, product, primaryEl) {
    const row = document.createElement('div');
    row.className = 'c-boost-product-item__cta-row';
    const col = document.createElement('div');
    col.className = 'c-boost-product-item__cta-col c-boost-product-item__cta-col--primary';
    col.appendChild(primaryEl);
    const sellControl = buildSellControl(product);
    row.appendChild(col);
    row.appendChild(sellControl);
    cta.appendChild(row);
  }

  const productCache = new Map();

  function getRoot() {
    const u = window.themeVariables.routes.rootUrlWithoutSlash;
    return u === '' || u === null || u === undefined ? '' : u;
  }

  function parseHandleFromHref(href) {
    if (!href || typeof href !== 'string') return null;
    try {
      const pathname = new URL(href, window.location.href).pathname;
      const m = pathname.match(/\/products\/([^/]+)\/?$/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) {
      return null;
    }
  }

  function getHandleFromProductItem(item) {
    const dataProduct = item.getAttribute('data-product');
    if (dataProduct) {
      try {
        const d = JSON.parse(dataProduct);
        if (d && typeof d.handle === 'string' && d.handle) {
          return d.handle;
        }
      } catch (e) { }
    }
    const byId = item.getAttribute('data-product-handle') || item.getAttribute('data-handle');
    if (byId) {
      return byId;
    }
    const link = item.querySelector('a[href*="/products/"]');
    if (link) {
      return parseHandleFromHref(link.getAttribute('href'));
    }
    return null;
  }

  function buildCurationMetaTagLine(tags) {
    if (!Array.isArray(tags)) {
      return '';
    }
    let curationHasNew = false;
    const condParts = [];
    const genderParts = [];
    for (const tag of tags) {
      const plain = String(tag).trim();
      if (plain.toLowerCase() === 'new') {
        curationHasNew = true;
      }
    }
    for (const tag of tags) {
      const s = String(tag);
      if (s.slice(0, 11) === '_condition_') {
        const piece = s.replace(/^_condition_/, '').trim();
        if (piece) {
          condParts.push(piece);
        }
      }
    }
    for (const tag of tags) {
      const s = String(tag);
      if (s.slice(0, 8) === '_gender_') {
        let piece = s.replace(/^_gender_/, '').trim();
        // FB#15: タグ値 womens は表示上 WOMEN'S に置換（タグはアポストロフィなしで保持しフィルタ互換を確保）
        if (piece.toLowerCase() === 'womens') {
          piece = "WOMEN'S";
        } else if (piece.toLowerCase() === 'mens') {
          piece = "MEN'S";
        }
        if (piece) {
          genderParts.push(piece);
        }
      }
    }
    const condStr = condParts.join(' | ');
    const genderStr = genderParts.join(' | ');
    let line = '';
    if (curationHasNew) {
      line = 'NEW';
    }
    if (condStr) {
      line = line ? `${line} | ${condStr}` : condStr;
    }
    if (genderStr) {
      line = line ? `${line} | ${genderStr}` : genderStr;
    }
    return line;
  }

  function getTagsAsArrayFromProductObject(product) {
    if (!product || product.tags == null) {
      return [];
    }
    if (Array.isArray(product.tags)) {
      return product.tags.map(String);
    }
    if (typeof product.tags === 'string') {
      return product.tags
        .split(',')
        .map(function (s) {
          return s.trim();
        })
        .filter(function (s) {
          return s !== '';
        });
    }
    return [];
  }

  function getMetafieldBadgesForHandle(handle) {
    const m = window.cBoostBadgeMetafieldsByHandle;
    if (!m || !handle) {
      return null;
    }
    const v = m[handle];
    if (v == null || v === '') {
      return null;
    }
    if (Array.isArray(v)) {
      return v.length ? v.map(String) : null;
    }
    return [String(v)];
  }

  function getCheapestVariantByPrice(variants) {
    if (!Array.isArray(variants) || !variants.length) {
      return null;
    }
    return variants.reduce(function (a, b) {
      return a.price <= b.price ? a : b;
    });
  }

  function formatSavingsMoney(cents) {
    const tvs = window.themeVariables && window.themeVariables.settings;
    const fmt = tvs && tvs.currencyCodeEnabled ? tvs.moneyWithCurrencyFormat : tvs && tvs.moneyFormat;
    if (typeof formatMoney === 'function') {
      return formatMoney(cents, fmt);
    }
    if (!Number.isFinite(cents)) {
      return '';
    }
    return (cents / 100).toFixed(2);
  }

  function buildDiscountLabelInnerHtml(product) {
    if (!showDiscount || !product || !product.available) {
      return null;
    }
    const price = Number(product.price);
    const compare =
      product.compare_at_price != null && product.compare_at_price !== '' ? Number(product.compare_at_price) : null;
    if (!Number.isFinite(price) || compare == null || !Number.isFinite(compare) || price >= compare) {
      return null;
    }
    const cheapest = getCheapestVariantByPrice(product.variants);
    if (!cheapest || cheapest.compare_at_price == null || cheapest.compare_at_price === '') {
      return null;
    }
    const mode = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.discountMode) || 'percentage';
    var savings;
    if (mode === 'percentage') {
      savings = String(Math.round(((compare - price) * 100) / compare)) + '%';
    } else {
      savings = formatSavingsMoney(compare - price);
    }
    const raw = (window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.collectionDiscount) || '';
    if (raw) {
      return String(raw).split('@savings@').join(savings);
    }
    return String(savings);
  }

  function focalImageLabelsOnlyNew() {
    const m = window.cBoostProductEnrich && window.cBoostProductEnrich.focalImageLabelsMode;
    return m === 'new_only' || m === 'new-only';
  }

  function mountFocalImageLabels(item, product) {
    const imgWrap = item.querySelector('.boost-sd__product-image-wrapper');
    if (!imgWrap || !product) {
      return;
    }
    const old = imgWrap.querySelector('.c-boost-focal-label-list');
    if (old) {
      old.remove();
    }
    const listEl = document.createElement('div');
    listEl.className = 'c-boost-focal-label-list product-item__label-list label-list';
    const tagList = getMergedTagsForProduct(item, product);

    if (focalImageLabelsOnlyNew()) {
      var newOnly = null;
      for (var n0 = 0; n0 < tagList.length; n0++) {
        if (String(tagList[n0]).trim().toLowerCase() === 'new') {
          newOnly = tagList[n0];
          break;
        }
      }
      if (newOnly == null) {
        return;
      }
      const newLabOnly = document.createElement('span');
      newLabOnly.className = 'label label--custom c-boost-focal-label--new';
      newLabOnly.textContent = String(newOnly).trim();
      listEl.appendChild(newLabOnly);
      imgWrap.insertBefore(listEl, imgWrap.firstChild);
      return;
    }

    const mf = getMetafieldBadgesForHandle(product.handle);
    if (mf && mf.length) {
      for (var i = 0; i < mf.length; i++) {
        const sp = document.createElement('span');
        sp.className = 'label ' + (i >= 1 ? 'label--custom2' : 'label--custom');
        sp.textContent = mf[i];
        listEl.appendChild(sp);
      }
    } else {
      for (var ti = 0; ti < tagList.length; ti++) {
        const t = String(tagList[ti]);
        if (t.indexOf('__label') === -1) {
          continue;
        }
        const sp = document.createElement('span');
        const isL2 = t.indexOf('__label2') !== -1;
        sp.className = 'label label--custom' + (isL2 ? '2' : '');
        const parts = t.split(':');
        const text = (parts.length ? String(parts[parts.length - 1]) : t).trim() || t;
        sp.textContent = text;
        listEl.appendChild(sp);
      }
    }
    var newTagRaw = null;
    for (var ni = 0; ni < tagList.length; ni++) {
      if (String(tagList[ni]).trim().toLowerCase() === 'new') {
        newTagRaw = tagList[ni];
        break;
      }
    }
    if (newTagRaw != null && !listEl.querySelector('.c-boost-focal-label--new')) {
      const newLab = document.createElement('span');
      newLab.className = 'label label--custom c-boost-focal-label--new';
      newLab.textContent = String(newTagRaw).trim();
      listEl.insertBefore(newLab, listEl.firstChild);
    }
    if (!product.available) {
      const so = document.createElement('span');
      so.className = 'label label--subdued';
      so.textContent = soldOut;
      listEl.appendChild(so);
    }
    const disc = buildDiscountLabelInnerHtml(product);
    if (disc) {
      const hl = document.createElement('span');
      hl.className = 'label label--highlight';
      hl.innerHTML = disc;
      listEl.appendChild(hl);
    }
    if (!listEl.childNodes.length) {
      return;
    }
    imgWrap.insertBefore(listEl, imgWrap.firstChild);
  }

  function getMergedTagsForProduct(item, product) {
    const fromApi = getTagsAsArrayFromProductObject(product);
    if (!item) {
      return fromApi;
    }
    const raw = item.getAttribute('data-product');
    if (!raw) {
      return fromApi;
    }
    try {
      const d = JSON.parse(raw);
      const t = d && d.tags;
      const fromData = Array.isArray(t)
        ? t
        : typeof t === 'string'
          ? t.split(',').map(function (s) {
            return s.trim();
          })
          : [];
      if (!fromData.length) {
        return fromApi;
      }
      const set = new Set(fromApi);
      fromData.forEach(function (x) {
        if (x != null && String(x).trim() !== '') {
          set.add(String(x).trim());
        }
      });
      return Array.from(set);
    } catch (e) {
      return fromApi;
    }
  }

  function extractCurationBrandFromTags(tags) {
    if (!Array.isArray(tags)) {
      return null;
    }
    for (const tag of tags) {
      const s = String(tag).trim();
      if (s.slice(0, 7) !== '_brand_') {
        continue;
      }
      if (s.toLowerCase() === '_brand_popular') {
        continue;
      }
      const candidate = s.replace(/^_brand_/, '').trim();
      if (!candidate) {
        continue;
      }
      if (candidate.toLowerCase() === 'popular') {
        continue;
      }
      return candidate;
    }
    return null;
  }

  function handleizeForCollectionHandle(name) {
    return String(name)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'all';
  }

  function mountTitleMetaBlock(item, product) {
    const tagList = getMergedTagsForProduct(item, product);
    const brandName = extractCurationBrandFromTags(tagList);
    if (!brandName) {
      return;
    }
    const productInfo = item.querySelector('.boost-sd__product-info');
    if (!productInfo) {
      return;
    }
    if (productInfo.querySelector('.c-boost-product-item__meta-top')) {
      return;
    }
    const top = document.createElement('div');
    top.className = 'c-boost-product-item__meta-top';
    // FB#56: 実在するコレクションが無い handle をリンク化すると 404 になるため、
    // Liquid から渡した実在コレクションのマップに載っているブランドだけリンクにする。
    const brandCollectionUrls = window.cBoostBrandCollectionUrls || {};
    const brandSlug = handleizeForCollectionHandle(brandName);
    const brandHref = Object.prototype.hasOwnProperty.call(brandCollectionUrls, brandSlug)
      ? brandCollectionUrls[brandSlug]
      : '';
    const useCollectionLink = strings.brandLinkToCollection === true && brandHref !== '';
    if (useCollectionLink) {
      const a = document.createElement('a');
      a.className = 'product-item-meta__vendor heading heading--xsmall c-product-item-curation__brand';
      a.href = brandHref;
      a.setAttribute('data-instant', '');
      a.textContent = brandName;
      a.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      top.appendChild(a);
    } else {
      const sp = document.createElement('span');
      sp.className =
        'product-item-meta__vendor heading heading--xsmall c-product-item-curation__brand c-product-item-curation__brand--text';
      sp.textContent = brandName;
      top.appendChild(sp);
    }
    const first = productInfo.firstElementChild;
    if (first) {
      productInfo.insertBefore(top, first);
    } else {
      productInfo.appendChild(top);
    }
  }

  function loadProductJson(handle) {
    if (productCache.has(handle)) {
      return productCache.get(handle);
    }
    const url = `${getRoot()}/products/${encodeURIComponent(handle)}.js`;
    const p = fetch(url, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : null))
      .catch(function () {
        return null;
      });
    productCache.set(handle, p);
    return p;
  }

  function getFirstAvailableVariant(variants) {
    if (!Array.isArray(variants) || !variants.length) {
      return null;
    }
    const v = variants.find((x) => x && x.available);
    return v || null;
  }

  function productUrlForQuickBuy(product) {
    if (!product || !product.url) {
      return '/';
    }
    if (product.url.startsWith('http')) {
      return product.url;
    }
    return new URL(product.url, window.location.origin).href;
  }

  function clearBoostInjections(item) {
    const focal = item.querySelector('.c-boost-focal-label-list');
    if (focal) {
      focal.remove();
    }
    const wrap = item.querySelector('.c-boost-product-item__enrichment');
    if (wrap) {
      wrap.remove();
    }
    const meta = item.querySelector('.c-boost-product-item__meta-top');
    if (meta) {
      meta.remove();
    }
    item.querySelectorAll('.c-boost-wishlist-slot').forEach(function (el) {
      el.remove();
    });
  }

  function resetProductItemsClobberedByBoost() {
    document
      .querySelectorAll('.' + BOOST_SCOPE + ' .boost-sd__product-item[data-c-boost-enrich-done="1"]')
      .forEach(function (item) {
        if (!item.querySelector('.c-boost-product-item__enrichment')) {
          item.removeAttribute('data-c-boost-enrich-done');
        }
      });
  }

  const C_BOOST_STAR_EMPTY = document.createElement('template');
  C_BOOST_STAR_EMPTY.innerHTML =
    '<svg fill="none" focusable="false" width="14" height="14" class="icon icon--rating-star rating__star rating__star--empty" viewBox="0 0 14 13" aria-hidden="true">' +
    '<path d="M7 0L8.6458 4.73475L13.6574 4.83688L9.66296 7.86525L11.1145 12.6631L7 9.8L2.8855 12.6631L4.33704 7.86525L0.342604 4.83688L5.3542 4.73475L7 0Z" fill="currentColor"></path></svg>';
  const C_BOOST_STAR_FULL = document.createElement('template');
  C_BOOST_STAR_FULL.innerHTML =
    '<svg fill="none" focusable="false" width="14" height="14" class="icon icon--rating-star rating__star rating__star--full" viewBox="0 0 14 13" aria-hidden="true">' +
    '<path d="M7 0L8.6458 4.73475L13.6574 4.83688L9.66296 7.86525L11.1145 12.6631L7 9.8L2.8855 12.6631L4.33704 7.86525L0.342604 4.83688L5.3542 4.73475L7 0Z" fill="currentColor"></path></svg>';

  function getStandardProductRatingInfo(product) {
    if (!product) {
      return null;
    }
    const m = product.metafields;
    if (m && m.reviews && m.reviews.rating && m.reviews.rating.value) {
      const v = m.reviews.rating.value;
      if (v && v.rating != null) {
        return {
          rating: Number(v.rating),
          min: v.scale_min != null ? Number(v.scale_min) : 1,
          max: v.scale_max != null ? Number(v.scale_max) : 5,
        };
      }
    }
    const map = window.cBoostReviewsRatingByHandle;
    const h = product.handle;
    if (h && map && map[h] && map[h].rating != null) {
      const o = map[h];
      return {
        rating: Number(o.rating),
        min: o.scale_min != null ? Number(o.scale_min) : 1,
        max: o.scale_max != null ? Number(o.scale_max) : 5,
      };
    }
    return null;
  }

  function cBoostInsertRatingGradientDef(cap, gradientId) {
    const w = document.createElement('div');
    w.className = 'c-boost-rating-grad-wrap';
    w.setAttribute('aria-hidden', 'true');
    w.innerHTML =
      '<svg class="c-boost-rating-grad" width="0" height="0" focusable="false"><defs><linearGradient id="' +
      gradientId +
      '" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="var(--c-rating-star-filled, #000)"></stop><stop offset="100%" stop-color="var(--c-rating-star-empty)"></stop></linearGradient></defs></svg>';
    cap.insertBefore(w, cap.firstChild);
  }

  function cBoostCreateHalfStarEl(gradientId) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('width', '14');
    svg.setAttribute('height', '14');
    svg.setAttribute('class', 'icon icon--rating-star-half rating__star rating__star--half');
    svg.setAttribute('viewBox', '0 0 14 13');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute(
      'd',
      'M7 0L8.6458 4.73475L13.6574 4.83688L9.66296 7.86525L11.1145 12.6631L7 9.8L2.8855 12.6631L4.33704 7.86525L0.342604 4.83688L5.3542 4.73475L7 0Z'
    );
    path.setAttribute('fill', 'url(#' + gradientId + ')');
    svg.appendChild(path);
    return svg;
  }

  function buildCurationStyleRatingBlock(product) {
    const purl = productUrlForQuickBuy(product);
    const info = getStandardProductRatingInfo(product);
    const row = document.createElement('div');
    row.className = 'c-product-item-curation__rating c-boost-product-item__rating';
    const a = document.createElement('a');
    // FB#55: 一覧のレビュー表示をクリックしたら商品ページのレビュー欄へ直接遷移させる
    a.className = 'product-item-meta__reviews-badge text--small c-boost-product-item__rating-link';
    a.href = `${purl}${purl.indexOf('#') === -1 ? '#c-pdp-review' : ''}`;
    // Boost の商品カード側クリックが先に走るとハッシュが落ちて通常の商品ページへ飛ぶため、
    // Sell ボタンと同じく伝播を止めて自前で遷移する。
    a.addEventListener('mousedown', function (e) {
      e.stopPropagation();
    });
    a.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const href = a.href;
      if (e.metaKey || e.ctrlKey) {
        window.open(href, '_blank', 'noopener,noreferrer');
        return;
      }
      window.location.assign(href);
    });
    const cap = document.createElement('div');
    cap.className = 'c-product-rating';
    const rating = document.createElement('div');
    rating.className = 'rating';
    const stars = document.createElement('div');
    stars.className = 'rating__stars';
    stars.setAttribute('role', 'img');
    if (info && !Number.isNaN(info.rating) && info.max) {
      const n = info.rating;
      const min = info.min != null ? info.min : 1;
      const m = Math.max(min, Math.min(5, info.max));
      const mod = n % 1;
      var ratingDecimal = 0;
      if (mod >= 0.3 && mod <= 0.7) {
        ratingDecimal = 0.5;
      } else if (mod > 0.7) {
        ratingDecimal = 1;
      }
      const ratingAsFloat = n;
      const gradId = 'c-boost-hg-' + (product && product.id ? String(product.id) : String(product.handle || 'x').replace(/[^a-z0-9-]/gi, ''));
      cBoostInsertRatingGradientDef(cap, gradId);
      for (var i = min; i <= m; i += 1) {
        if (ratingAsFloat >= i) {
          stars.appendChild(C_BOOST_STAR_FULL.content.cloneNode(true).firstElementChild);
        } else {
          if (ratingDecimal === 0.5) {
            stars.appendChild(cBoostCreateHalfStarEl(gradId));
            ratingDecimal = 0;
          } else if (ratingDecimal === 1) {
            stars.appendChild(C_BOOST_STAR_FULL.content.cloneNode(true).firstElementChild);
            ratingDecimal = 0;
          } else {
            stars.appendChild(C_BOOST_STAR_EMPTY.content.cloneNode(true).firstElementChild);
          }
        }
      }
      const ratingAvg = Math.round(n * 10) / 10;
      const capSpan = document.createElement('span');
      capSpan.className = 'rating__caption';
      capSpan.textContent = String(ratingAvg);
      stars.setAttribute(
        'aria-label',
        String(ratingAvg) + ' out of ' + String(m) + ' stars'
      );
      rating.appendChild(stars);
      rating.appendChild(capSpan);
    } else {
      for (var j = 0; j < 5; j += 1) {
        stars.appendChild(C_BOOST_STAR_EMPTY.content.cloneNode(true).firstElementChild);
      }
      stars.setAttribute(
        'aria-label',
        (strings.ratingNoReviewsAria && String(strings.ratingNoReviewsAria)) || '0 out of 5 stars'
      );
      rating.appendChild(stars);
    }
    cap.appendChild(rating);
    a.appendChild(cap);
    row.appendChild(a);
    return row;
  }

  function buildJudgeMePlaceholder(product) {
    const w = document.createElement('div');
    w.className = 'jdgm-widget jdgm-preview-badge c-boost-jdgm-root';
    w.setAttribute('data-id', String(product && product.id ? product.id : ''));
    w.setAttribute('data-template', 'collection');
    if (product && product.url) {
      var abs = String(product.url);
      try {
        if (!abs.startsWith('http')) {
          abs = new URL(product.url, window.location.origin).href;
        }
      } catch (e) { }
      w.setAttribute('data-permalink', abs);
      w.setAttribute('data-link', abs);
    }
    if (product && product.title) {
      w.setAttribute('data-product-title', product.title);
    }
    if (product && product.handle) {
      w.setAttribute('data-product-handle', product.handle);
    }
    return w;
  }

  function mountWishlistButton(item, product) {
    if (!product || !product.id) {
      return;
    }
    const imgWrap = item.querySelector('.boost-sd__product-image-wrapper');
    if (!imgWrap || imgWrap.querySelector('.c-boost-wishlist-slot')) {
      return;
    }
    const wk = document.createElement('wishlist-button-collection');
    wk.className = 'c-boost-wishlist-slot';
    wk.setAttribute('data-product-handle', product.handle || '');
    const vForWishlist = getFirstAvailableVariant(product.variants);
    const variantId = vForWishlist && vForWishlist.id ? vForWishlist.id : product.variants && product.variants[0] && product.variants[0].id;
    if (variantId) {
      wk.setAttribute('data-variant-id', String(variantId));
    }
    wk.setAttribute('show-icon', '');
    wk.setAttribute('icon', 'wishlist');
    wk.setAttribute('align-self', 'center');
    wk.setAttribute('align-content', 'center');
    imgWrap.appendChild(wk);
  }


  function buildEnrichmentDom(product, item) {
    const wrap = document.createElement('div');
    wrap.className = 'c-boost-product-item__enrichment';

    const tagList = getMergedTagsForProduct(item, product);
    const line = buildCurationMetaTagLine(tagList);
    if (line) {
      const tags = document.createElement('div');
      tags.className = 'c-product-item-curation__tags c-boost-product-item__tags';
      const lineEl = document.createElement('span');
      lineEl.className = 'c-product-item-curation__tag-line';
      lineEl.textContent = line;
      tags.appendChild(lineEl);
      wrap.appendChild(tags);
    }

    if (!judgeMeOnBoost) {
      wrap.appendChild(buildCurationStyleRatingBlock(product));
    } else {
      wrap.appendChild(buildJudgeMePlaceholder(product));
    }

    const cta = document.createElement('div');
    cta.className = 'c-boost-product-item__cta-wrapper product-item__cta-wrapper';

    // FB#57: 売り切れ時も Sell ボタンだけは表示する（Buy は出さない）。
    if (!product.available) {
      const soldRow = document.createElement('div');
      soldRow.className = 'c-boost-product-item__cta-row c-boost-product-item__cta-row--sell-only';
      soldRow.appendChild(buildSellControl(product));
      cta.appendChild(soldRow);
      wrap.appendChild(cta);
      return wrap;
    }

    if (product.variants && product.variants.length === 1) {
      const v = getFirstAvailableVariant(product.variants);
      if (!v) {
        return wrap;
      }
      const form = document.createElement('form');
      const formId = `boost-c-product-form-${product.id}`;
      form.setAttribute('is', 'product-form');
      form.setAttribute('method', 'post');
      form.setAttribute(
        'action',
        window.themeVariables.routes.cartAddUrl || `${getRoot()}/cart/add`
      );
      form.setAttribute('enctype', 'multipart/form-data');
      form.setAttribute('id', formId);
      form.setAttribute('accept-charset', 'UTF-8');
      const q = document.createElement('input');
      q.type = 'hidden';
      q.name = 'quantity';
      q.value = '1';
      const idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id';
      idInput.value = String(v.id);
      const btn = document.createElement('button');
      btn.type = 'submit';
      btn.setAttribute('is', 'loader-button');
      btn.className =
        'c-boost-product-item__btn-buy c-boost-product-item__btn-buy--single product-item__cta button button--primary';
      btn.textContent = buyLabel;
      form.appendChild(q);
      form.appendChild(idInput);
      form.appendChild(btn);
      appendCtaRowWithSell(cta, product, form);
    } else {
      const purl = productUrlForQuickBuy(product);
      const sid = `boost-qb-${product.id}`;
      const b1 = document.createElement('button');
      b1.type = 'button';
      b1.setAttribute('is', 'toggle-button');
      b1.setAttribute('loader', '');
      b1.setAttribute('aria-controls', `${sid}-drawer`);
      b1.setAttribute('aria-expanded', 'false');
      b1.className =
        'c-boost-product-item__btn-buy c-boost-product-item__btn-buy--multi product-item__cta button button--primary hidden-phone';
      b1.textContent = buyLabel;
      const b2 = document.createElement('button');
      b2.type = 'button';
      b2.setAttribute('is', 'toggle-button');
      b2.setAttribute('aria-controls', `${sid}-popover`);
      b2.setAttribute('aria-expanded', 'false');
      b2.className =
        'c-boost-product-item__btn-buy c-boost-product-item__btn-buy--multi product-item__cta button button--primary hidden-tablet-and-up';
      b2.textContent = buyLabel;
      const multi = document.createElement('div');
      multi.className = 'c-boost-product-item__primary-actions';
      multi.appendChild(b1);
      multi.appendChild(b2);
      const pop = document.createElement('quick-buy-popover');
      pop.id = `${sid}-popover`;
      pop.setAttribute('href', purl);
      pop.className = 'popover popover--quick-buy hidden-tablet-and-up';
      const dr = document.createElement('quick-buy-drawer');
      dr.id = `${sid}-drawer`;
      dr.setAttribute('href', purl);
      dr.className = 'drawer drawer--large drawer--quick-buy hidden-phone';
      appendCtaRowWithSell(cta, product, multi);
      cta.appendChild(pop);
      cta.appendChild(dr);
    }

    wrap.appendChild(cta);
    return wrap;
  }

  function mountEnrichment(item, product) {
    clearBoostInjections(item);
    mountFocalImageLabels(item, product);
    mountTitleMetaBlock(item, product);
    mountWishlistButton(item, product);
    const infoWrapper = item.querySelector('.boost-sd__product-info-wrapper') || item;
    const after =
      item.querySelector('.boost-sd__product-info') ||
      item.querySelector('.boost-sd__product-link:not(.boost-sd__product-image)') ||
      null;
    const el = buildEnrichmentDom(product, item);
    if (after && after.parentNode === infoWrapper) {
      after.insertAdjacentElement('afterend', el);
    } else {
      infoWrapper.appendChild(el);
    }
    if (judgeMeOnBoost) {
      requestAnimationFrame(function () {
        runJudgeMeCaptionFormat();
      });
      [250, 900].forEach(function (ms) {
        setTimeout(function () {
          runJudgeMeCaptionFormat();
        }, ms);
      });
      planJudgeMeBootstrap();
    }
  }

  let scheduled = false;
  function scheduleScan() {
    if (scheduled) {
      return;
    }
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      scan();
    });
  }

  function scan() {
    tagBoostScopeClass();
    patchSortButtonAccessibility();
    patchFilterToggleLabel();
    resetProductItemsClobberedByBoost();
    const items = document.querySelectorAll(
      '.' + BOOST_SCOPE + ' .boost-sd__product-item:not([data-c-boost-enrich-done])'
    );
    items.forEach(function (item) {
      if (item.closest('.c-boost-skip') || item.getAttribute('data-c-boost-enrich-skip') === 'true') {
        item.setAttribute('data-c-boost-enrich-done', '1');
        return;
      }
      const handle = getHandleFromProductItem(item);
      if (!handle) {
        item.setAttribute('data-c-boost-enrich-done', 'no-handle');
        return;
      }
      item.setAttribute('data-c-boost-enrich-done', 'loading');
      loadProductJson(handle).then(function (product) {
        if (!product || !item.isConnected) {
          item.setAttribute('data-c-boost-enrich-done', '0');
          return;
        }
        mountEnrichment(item, product);
        item.setAttribute('data-c-boost-enrich-done', '1');
      });
    });
  }

  if (window.MutationObserver) {
    const mo = new MutationObserver(function (mutations) {
      let any = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) {
            return;
          }
          if (!n.matches) {
            return;
          }
          if (
            n.matches('.boost-sd__product-item') ||
            n.querySelector?.('.boost-sd__product-item') ||
            n.matches('.boost-sd__fpl-app-block') ||
            n.matches('.boost-sd__filter-product-list') ||
            n.querySelector?.('.boost-sd__fpl-app-block, .boost-sd__filter-product-list') ||
            n.matches('.boost-sd__sorting') ||
            n.querySelector?.('.boost-sd__sorting') ||
            n.matches('.boost-sd__toolbar-top-mobile') ||
            n.querySelector?.('.boost-sd__filter-tree-toggle-button')
          ) {
            any = true;
          }
        });
      });
      if (any) {
        scheduleScan();
      }
    });
    if (document.body) {
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  function initBoostEnrich() {
    tagBoostScopeClass();
    patchFilterToggleLabel();
    scheduleScan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBoostEnrich);
  } else {
    initBoostEnrich();
  }
})();
